import React, { useState } from "react";
import "../index.css";

const AddDriver = () => {
  const [driverData, setDriverData] = useState({
    firstname: "",
    lastname: "",
    dob: "",
    gender: "",
    area: "",
    image: null,
  });

  const handleChange = (e) => {
    setDriverData({ ...driverData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    setDriverData({ ...driverData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstname, lastname, dob, gender, area, image } = driverData;

    if (!firstname || !lastname || !dob || !gender || !area || !image) {
      alert("All fields are required!");
      return;
    }

    const formData = new FormData();
    Object.entries(driverData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND}/api/driver`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        alert("Driver details uploaded successfully!");
        setDriverData({
          firstname: "",
          lastname: "",
          dob: "",
          gender: "",
          area: "",
          image: null,
        });
      } else {
        alert("Error: " + (data.error || "Unknown error"));
      }
    } catch (error) {
      alert("Error uploading driver details");
    }
  };

  return (
    <div className="add-driver-container container mt-4">
      <h2 className="add-driver-title text-center mb-4">Upload Driver Details</h2>
      <form className="add-driver-form" onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label>First Name:</label>
          <input
            type="text"
            name="firstname"
            className="form-control"
            onChange={handleChange}
            value={driverData.firstname}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label>Last Name:</label>
          <input
            type="text"
            name="lastname"
            className="form-control"
            onChange={handleChange}
            value={driverData.lastname}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label>Gender:</label>
          <select
            name="gender"
            className="form-control"
            onChange={handleChange}
            value={driverData.gender}
            required
          >
            <option value="" disabled>Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>

        <div className="form-group mb-3">
          <label>Area:</label>
          <input
            type="text"
            name="area"
            className="form-control"
            onChange={handleChange}
            value={driverData.area}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label>Date of Birth:</label>
          <input
            type="date"
            name="dob"
            className="form-control"
            onChange={handleChange}
            value={driverData.dob}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label>Upload Driver Image:</label>
          <input
            type="file"
            name="image"
            className="form-control"
            onChange={handleImageUpload}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-100 mt-3">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddDriver;
